const TedSaveWhiteIcon = () => (
  <div>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7418 4.89844H4.2584C2.8334 4.89844 1.66675 6.06509 1.66675 7.49009V16.9568C1.66675 18.1651 2.53341 18.6818 3.59175 18.0901L6.86674 16.2651C7.21674 16.0734 7.78341 16.0734 8.12508 16.2651L11.4001 18.0901C12.4584 18.6818 13.3251 18.1651 13.3251 16.9568V7.49009C13.3334 6.06509 12.1668 4.89844 10.7418 4.89844Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 7.49009V16.9568C13.3334 18.1651 12.4667 18.6734 11.4084 18.0901L8.13342 16.2651C7.78342 16.0734 7.21674 16.0734 6.86674 16.2651L3.59175 18.0901C2.53341 18.6734 1.66675 18.1651 1.66675 16.9568V7.49009C1.66675 6.06509 2.8334 4.89844 4.2584 4.89844H10.7418C12.1668 4.89844 13.3334 6.06509 13.3334 7.49009Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3334 4.25572V13.7224C18.3334 14.9307 17.4668 15.4391 16.4084 14.8557L13.3334 13.1391V7.48905C13.3334 6.06405 12.1668 4.8974 10.7418 4.8974H6.66675V4.25572C6.66675 2.83072 7.8334 1.66406 9.2584 1.66406H15.7418C17.1668 1.66406 18.3334 2.83072 18.3334 4.25572Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedSaveWhiteIcon;
